var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex",style:(_vm.addedPadding)},[_c('p',{staticClass:"question-body"},[_vm._v(_vm._s(_vm.label)+".")]),_c('p',{staticClass:"question-body"},[_vm._v(_vm._s(_vm.question))])])}
var staticRenderFns = []

export { render, staticRenderFns }